import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "l-page home" }
const _hoisted_2 = {
  key: 0,
  class: "p-top p-top--guest l-container"
}
const _hoisted_3 = { class: "p-top__sec" }
const _hoisted_4 = { class: "p-top__ttl" }
const _hoisted_5 = { class: "p-top__card-container" }
const _hoisted_6 = { class: "p-cards" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "c-card__ttl" }, "ログインして利用する", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "c-card__img" }, "ログイン イメージ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "c-card__txt" }, "会員の⽅はこちら", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "ログイン", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "c-card__ttl" }, "新規会員登録する", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "c-card__img" }, "新規会員登録 イメージ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "c-card__txt" }, "会員登録をされていない⽅はこちら", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "新規会員登録", -1)
const _hoisted_15 = { class: "p-top__sec" }
const _hoisted_16 = { class: "p-top__ttl" }
const _hoisted_17 = {
  key: 1,
  class: "p-top p-top--member l-container"
}
const _hoisted_18 = { class: "p-top__sec" }
const _hoisted_19 = { class: "p-top__ttl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ProcedureMenu = _resolveComponent("ProcedureMenu")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (!_ctx.loginStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", {
                class: _normalizeClass(["p-top__ttl__main js-animation_fadeUp ts-00", { 'is-on': _ctx.isOnRef }])
              }, "SHUEISHA ID", 2),
              _createElementVNode("h2", {
                class: _normalizeClass(["p-top__ttl__sub js-animation_fadeUp ts-00", { 'is-on': _ctx.isOnRef }])
              }, "サイトへようこそ！", 2)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(["c-card c-card--signin js-animation_fadeUp ts-01", { 'is-on': _ctx.isOnRef, 'is-hover': _ctx.isLoginHoverRef }])
                }, [
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _createVNode(_component_router_link, {
                    to: { name: 'Login' },
                    class: "c-card__btn c-btn c-btn--color",
                    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isLoginHoverRef = true)),
                    onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isLoginHoverRef = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["c-card c-card--signup js-animation_fadeUp ts-02", { 'is-on': _ctx.isOnRef, 'is-hover': _ctx.isSignupHoverRef }])
                }, [
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_router_link, {
                    to: { name: 'Signup' },
                    class: "c-card__btn c-btn c-btn--color",
                    onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSignupHoverRef = true)),
                    onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isSignupHoverRef = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ], 2)
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h2", {
                class: _normalizeClass(["p-top__ttl__sub js-scroll_fadeUp ts-00", { 'is-on': _ctx.isScrollOn1Ref }]),
                ref: "jsScrollfadeUp1Ref"
              }, "手続きメニュー", 2)
            ]),
            _createVNode(_component_ProcedureMenu)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("section", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h1", {
                class: _normalizeClass(["p-top__ttl__main js-animation_fadeUp ts-00", { 'is-on': _ctx.isOnRef }])
              }, "SHUEISHA ID", 2),
              _createElementVNode("h2", {
                class: _normalizeClass(["p-top__ttl__sub js-animation_fadeUp ts-00", { 'is-on': _ctx.isOnRef }])
              }, "手続きメニュー", 2)
            ]),
            _createVNode(_component_ProcedureMenu)
          ])
        ]))
  ]))
}